import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionLogosProjection = (localeId: LocaleId) => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
        _key,
        _type,
        spacing,
        topBorder,
        ${coalesceLocaleField('title', localeId)},
        logos[] {
          _key,
          image${MEDIA_PROJECTION}
        }
      }
  `
}
